const createSite = {
  form: {
    header: {
      title: 'שלום',
    },

    fields: {
      sitePlaceHolder: 'אנא מלא את שם האתר שלך',
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    information: {
      details: {
        header: 'איזה תרחיש תרצה להזרים עם Moovex?',
        instructions: 'אנא סמן את התחום המתאר את תחום העיסוק שלך בצורה הטובה ביותר.',
      },
    },

    button: 'אני רוצה לבנות תרחיש',
  },
};

export default createSite;
